// React
import React from 'react';
import ReactDOM from 'react-dom/client';

// Components
import App from './App';
import store from './store/Store';

// Modules
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';

// HTML Element 
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render
root.render(
    <Provider store={store}>
      <App />
    </Provider>
);
